module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/solution-03_sp-05796b29eba10a2aa124565e585da390.jpg";